export const HOME = {
    emergentLink: 'home-emergent-link',
    newTripButton: 'home-new-trip-button',
    saveIdeaButton: 'home-save-idea-button',
    activeTripsSection: 'home-active-trips-section',
    inspirationSection: 'home-inspiration-section',
    wishlistSection: 'home-wishlist-section',
    tripCard: 'home-trip-card',
    inspirationCard: 'home-inspiration-card',
    wishlistItem: 'home-wishlist-item',
    pinIdeaButton: 'home-pin-idea-button',
    startPlanningButton: 'home-start-planning-button',
};
